import React from 'react';
import '../../../css/buttons/SecondaryButton.css';

const SecondaryButton = ({ onClick, text }) => {
  return (
    <button className="secondary-button" onClick={onClick}>
      <div className="button-text">{text}</div>
    </button>
  );
}

export default SecondaryButton;